export const CUSTOMER_ADDRESS_FIELDS = {
  line_1: 'line_1',
  city: 'city',
  country: 'country',
  zip: 'zip',
  state: 'state'
};

export const CUSTOMER_FIELDS = {
  name: 'name',
  email: 'email',
  phone: 'phone_number',
  addresses: 'addresses',
  business_vat_id: 'business_vat_id',
  ...CUSTOMER_ADDRESS_FIELDS
};

export const CUSTOMER_PREFIX = 'customer';
export const CUSTOMER_ADDRESSES_PREFIX = `${CUSTOMER_PREFIX}.${CUSTOMER_FIELDS.addresses}`;

export const CUSTOMER_AFT_FIELDS = {
  name: 'name',
  phone_number: 'phone_number',
  ...CUSTOMER_ADDRESS_FIELDS
};

export const PHONE_COUNTRY_CODE = 'countryCode';
export const PHONE_NUMBER = 'number';

export const PHONE_NUMBER_FIELD = {
  country: PHONE_COUNTRY_CODE,
  number: PHONE_NUMBER
};

export const CUSTOMER_MAX_PHONE_NUMBER_DB_CHARS = {
  [CUSTOMER_FIELDS.name]: 255,
  [CUSTOMER_FIELDS.email]: 255,
  [CUSTOMER_FIELDS.business_vat_id]: 45,
  [CUSTOMER_FIELDS.phone]: 20,
  [CUSTOMER_FIELDS.line_1]: 255,
  [CUSTOMER_FIELDS.city]: 255,
  [CUSTOMER_FIELDS.state]: 255,
  [CUSTOMER_FIELDS.zip]: 20
};

export const CUSTOMER_TOKENIZATION_FORM_ID = 'customer-tokenization-form';
